export const regexPatterns = {
  float: /^[0-9]+[.,]?[0-9]*$/
};
